import Axios from 'axios';
import store from '../store/index';
import { errorLog } from '@/utils/logger';

const createApi = () => {
  const config = {
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
      common: {
        'Content-Type': 'application/json',
      },
    },
  };

  const instance = Axios.create(config);

  instance.interceptors.request.use(config => {
    const { accessToken } = store.state.auth;
    config.headers.token = !config.headers.token
      ? accessToken
      : config.headers.token;

    return config;
  });

  instance.interceptors.response.use(null, error => {
    const { status } = error?.response || {};

    if (status === 401) {
      errorLog('session expired');
      alert(
        'Sua sessão expirou. Você será redirecionado para que efetue o login novamente.',
      );
      store.dispatch('auth/logout');
    }

    return Promise.reject(error);
  });

  return instance;
};

export default createApi;
